import React from 'react';
import Container from '../Container/Container';
import Button from '../Button/Button';
import Message from '../Message/Message';
import './ConnectionError.css';

interface ErrorProps {
  title?: string;
  message?: string;
  // Optional back navigation — renders a second button when provided
  onBack?: () => void;
  // Pre-translated label for the back button
  backLabel?: string;
}

const ConnectionError = ({ title, message, onBack, backLabel }: ErrorProps) => (
  <Container className="connection-error">
    <div className="white-box">
      <h1>{title || <Message id={'connectionError.title'} />}</h1>
      <p>{message || <Message id="connectionError.description" />}</p>
      <div className="connection-error-buttons">
        <Button onClick={() => location.reload()}>
          <Message id="tryAgain" />
        </Button>
        {onBack && backLabel && (
          // light color = light gray; placed inline next to "Try again"
          <Button onClick={onBack} color="light">
            {backLabel}
          </Button>
        )}
      </div>
    </div>
  </Container>
);

export default ConnectionError;
